import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/CartPopup.css";

const CartPopup = ({ isOpen, onClose, cartItems, removeFromCart, total }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);

  if (!isOpen) return null;
  const isCartEmpty = cartItems.length === 0;

  return (
    <>
      <div className="cart-overlay" onClick={onClose}></div>
      <div className="cart-popup">
        <div className="cart-popup-header">
          <h3>Produsele din cos</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="cart-popup-divider-small"></div>

        <div className="widget-shopping-cart-content">
          {isCartEmpty ? (
            <div className="empty-cart">
              <i className="fa-solid fa-shopping-bag"></i>
              <p>Nu ai niciun produs in cos!</p>
            </div>
          ) : (
            <div className="widget-shopping-cart">
              <ul className="commerce-mini-cart">
                {cartItems.map((item, index) => (
                  <li key={item.id}>
                    <li className="cart-item">
                      <div className="cart-item-image">
                        <img src={item.image} alt={item.name} />
                      </div>
                      <div className="cart-item-details">
                        <h4>{item.name}</h4>
                        <p>
                          {item.quantity} x {item.price} lei
                        </p>
                      </div>
                      <button
                        className="remove-item"
                        onClick={() => removeFromCart(item.id)}
                      >
                        ×
                      </button>
                    </li>

                    {item.extras && item.extras.length > 0 && (
                      <div className="extras-container">
                        {item.extras.map((extra) => (
                          <div
                            key={extra.id}
                            className="cart-item cart-item-extra"
                          >
                            <div className="cart-item-image">
                              <img src={extra.image} alt={extra.name} />
                            </div>
                            <div className="cart-item-details">
                              <h4>{extra.name}</h4>
                              <p>1 x {extra.price} lei</p>
                            </div>
                            <button
                              className="remove-item"
                              onClick={() => removeFromCart(item.id, extra.id)}
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                    {item.greetingText && (
                      <div className="greeting-section">
                        <label className="form-section ">
                          <strong>Text pentru felicitare: </strong>
                          <p className="form-text-greeting">
                            {item.greetingText}
                          </p>
                        </label>
                      </div>
                    )}
                    <div className="delivery-info">
                      <p>
                        <strong>Data de livrare:</strong> {item.deliveryDate}
                      </p>
                      <p>
                        <strong>Ora: </strong>
                        {item.deliveryTime}
                      </p>
                    </div>
                    {index < cartItems.length - 1 && (
                      <div className="item-divider"></div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* <div className="widget-info-cart-content">
          <p className="shipping-note">
            Costul de transport va fi calculat după alegerea orașului pentru
            livrare.
          </p>

          <div className="cart-popup-divider thick"></div>

          <div className="total-section">
            <span>Total pentru plată:</span>
            <span className="total-amount">{total} lei</span>
          </div>

          <div className="cart-popup-divider-small"></div>

          <div className="cart-buttons">
            <Link to="/cos" className="btn view-cart-btn" onClick={onClose}>
              Vezi cosul
            </Link>
            <Link to="/checkout" className="btn checkout-btn" onClick={onClose}>
              Finalizare
            </Link>
          </div>
        </div> */}
        {!isCartEmpty && (
          <div className="widget-info-cart-content">
            <p className="shipping-note">
              Costul de transport va fi adăugat după alegerea orașului pentru
              livrare.
            </p>

            <div className="cart-popup-divider thick"></div>

            <div className="total-section">
              <span>Total pentru plată:</span>
              <span className="total-amount">{total} lei</span>
            </div>

            <div className="cart-popup-divider-small"></div>

            <div className="cart-buttons">
              <Link to="/cos" className="btn view-cart-btn" onClick={onClose}>
                Vezi cosul
              </Link>
              <Link
                to="/checkout"
                className="btn checkout-btn"
                onClick={onClose}
              >
                Finalizare
              </Link>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CartPopup;
